import { useStreamUserDefinedRange } from '../../stores/stream-screen.store';
import { useLoadRangeAtTs } from '../range/useLoadRangeAtTs';

/**
 * Hook to move the stream forward.
 */

export function useGoForward() {
  const range = useStreamUserDefinedRange();
  const loadStream = useLoadRangeAtTs();

  return (ms: number) => {
    return loadStream(range.from + ms);
  };
}
